const closeButtonLabel = "Zatvoriť";
const skSK = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  skSK as default
};
